/**
 * CommentSingle
 */

import Config from '../../Config';
import Util from '../../Util';
import Template from '../Template';
import ParamInfo from '../ParamInfo';
import Comment from './Comment';
import PageNavigation from '../PageNavigation';

class CommentSingle extends Comment {

	public commentLoaded: any;

	protected $node: any;

	protected options: any;

	protected _id: string;

	protected articleId: string;

	protected inited: boolean;

	protected template: any;

	protected orderType: string;

	protected isFirstLoaded: boolean;

	protected paramInfo: ParamInfo;

	protected pageNavigation: PageNavigation;

	protected loading: any;

	protected commentReply: any;

	protected commentListWrap: any;

	constructor( node: any, options: any ) {

		super( node, options );

		this.$node = node;

		this._id = this.$node.attr( 'id' );

		Config.guid = ( window as any ).userData.guid;

		this.articleId = options.articleId;

		// orderType is the DESC
		this.orderType = Config.commentOrderByDesc;

		this.isFirstLoaded = false;

		// parameter & hash Module - page, query, searchType, articleId
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();

		// pagenavigation Module
		this.pageNavigation = new PageNavigation( this.paramInfo );

		// comment Loaded
		this.commentLoaded.add( ( data: any ) => {
			const more = this.pageNavigation.setUI( data.pageNavigation );
			jQuery( `#${this._id} .pagination-container` ).replaceWith( more );
		}, this );

		this.addPagingEvent();
	}

	public addPagingEvent() {
		jQuery( 'body' ).on( 'click', `#${this._id} .pagination-list a`, ( evt ) => {
			evt.preventDefault();
			const page = jQuery( evt.currentTarget ).attr( 'data-paging' ) || 1;
			this.get( page );
		});
	}

	public get( page: string|number ) {
		this.loading.show();

		const articleId = this.articleId;

		const commentUrl = Util.Tmpl.render({
			data: {
				articleId,
				board: Config.board,
				size: Config.commentListSize,
				orderType: this.orderType,
				page: page || 1,
			},
			template: Config.commentVote,
		});

		const comment = Util.get( commentUrl );
		comment.then( ( data: any ) => {
			let header = '';
			let write = '';
			let commentReply;
			let body = '';

			data = Util.convertCamelCase( data );

			// set comment Header UI
			if ( !this.isFirstLoaded ) {
				header =  this.commentHeader.setUI( data.pageNavigation || data.commentPagination );
			}

			// set comment write textare UI
			if ( !this.isFirstLoaded ) {
				write = this.commentWrite.setUI();
			}

			// set comment Reply textarea UI
			if ( !this.isFirstLoaded ) {
				commentReply = this.commentReply.setUI();
			}

			// set comment List UIcommentList
			body = this.commentListWrap.setUI( Template.commentList( data ) );

			jQuery( `#${this._id} .pagination-container` ).remove();
			const more = ( !Config.isPaging ) ?
				this.commentMore.setUI() :
				this.pageNavigation.setUI( data.pageNavigation );

			// merge comment Template String
			if ( this.isFirstLoaded ) {
				jQuery( `#${this._id} .comment-body` ).replaceWith( body + more );
			} else {
				const wrapComment = Template.comment( header + write + body + more );
				this.$node.append( jQuery( wrapComment ).fadeIn() );
			}

			if ( !this.isFirstLoaded ) {
				this.$node.append( commentReply.hide() );
			}

			this.myLikeComment( data.likeCommentIds );

			// If it's the last page, remove more button
			if ( ( data.pageNavigation && data.pageNavigation.endPage <= 1 ) ||
					( data.commentPagination && data.commentPagination.endPage <= 1 )	) {
				this.commentMore.remove();
			}

			// If comment is an empty array... change the placeholder text
			if ( !this.getCount( data.pageNavigation || data.commentPagination ) ) {
				this.commentWrite.setPlaceHolder( Config.L10N.comment_placeholder_empty );
			}

			// It's works, If Config.commentPlaceholder is not empty
			if ( Config.commentPlaceholder ) {
				this.commentWrite.setPlaceHolder( Config.commentPlaceholder );
			}

			this.loading.hide();

			this.isFirstLoaded = true;

		}, () => {

			this.loading.hide();

		});
	}
}

export default CommentSingle;
